import { useEngineQuery } from "./_shims";
import { useSession } from "./_shims";
import { useConversations, useMatchCards, useShares } from "./lib/hooks";

/** Nav badges: introductions waiting on you (cached cards), unread Hub messages, and people shared with you still waiting. */
export function useNetworkBadges(): { matchesWaiting: number; messagesUnread: number; sharesPending: number } {
  const { user } = useSession();
  const cards = useMatchCards();
  const cached = useEngineQuery("getMatchCards", { section: "waiting_on_you" }, { enabled: !cards.data });
  const convs = useConversations(false);
  const shares = useShares(true, true);
  const waitingFromCards = cards.data ? cards.data.cards.filter((c) => c.section === "waiting_on_you").length : (cached.data?.length ?? 0);
  const messagesUnread = (convs.data?.conversations ?? []).reduce((n, c) => n + (c.unread ?? 0), 0);
  const sharesPending = (shares.data?.shares ?? []).filter((sh) => sh.toUserId === user?.id && sh.status === "pending").length;
  return { matchesWaiting: waitingFromCards, messagesUnread, sharesPending };
}
